import React from "react";
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";
import StoreIcon from "@mui/icons-material/Store";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import { RELEASE_TYPES, ReleaseType } from "./releaseTypes";

const OPTIONS: Record<ReleaseType, { label: string; Icon: typeof PersonIcon }> = {
  patient: { label: "Patient", Icon: PersonIcon },
  employee: { label: "Staff", Icon: BadgeIcon },
  clinic: { label: "Clinic", Icon: StoreIcon },
  treatment: { label: "Treatment", Icon: MedicalServicesIcon },
};

/** Release kind segmented switch, used by Add Release and All Release. */
function ReleaseTypeSwitch<T extends ReleaseType>({ value, onChange, types }: ReleaseTypeSwitchProps<T>) {
  return (
    <div className="flex gap-1.5 p-1 bg-slate-100 dark:bg-slate-700 rounded-lg" role="tablist">
      {(types ?? (RELEASE_TYPES as T[])).map((type) => {
        const { label, Icon } = OPTIONS[type];
        const active = value === type;
        return (
          <button
            key={type}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(type)}
            className={`flex-1 sm:flex-none flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-all ${
              active
                ? "bg-white dark:bg-slate-600 text-primary dark:text-sky-300 shadow-sm"
                : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200"
            }`}
          >
            <Icon sx={{ fontSize: 14 }} />
            {label}
          </button>
        );
      })}
    </div>
  );
}

export default ReleaseTypeSwitch;

interface ReleaseTypeSwitchProps<T extends ReleaseType> {
  value: T;
  onChange: (type: T) => void;
  /** Kinds to offer; all of them when left out. */
  types?: T[];
}
